$(function() {
    var dirRtlFlag = false;
    if ($("html").attr('dir') == 'rtl') {
        dirRtlFlag = true;
    }

    $('#home-deps').slick({
        dots: false,
        infinite: true,
        speed: 3000,
        rtl: dirRtlFlag,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1,
        pauseOnHover: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings:{
              slidesToShow: 6,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 800,
            settings:{
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings:{
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings:{
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
        ]
    });

    if(dirRtlFlag){
      dirRtlFlag = false;
    } else {
      dirRtlFlag = true;
    }

    $('#home-cust').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        rtl: dirRtlFlag,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false,
        slidesToShow: 8,
        slidesToScroll: 4,
        prevArrow: '#btn-prv',
        nextArrow: '#btn-nxt',
        responsive: [
          {
            breakpoint: 1024,
            settings:{
              slidesToShow: 6,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 800,
            settings:{
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings:{
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings:{
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
        ]
    });


});
